import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import "../Membership/membershipList.css";
import axiosInstance from "../../Services/axios";
import MembershipCard from "../../Components/MembershipCard/MembershipCard";
import "./membershipDetail.css";
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useSelector } from "react-redux";
import { fetchVendorMembershipList } from "../../Services/api";
import { showToast } from "../../Components/toastConfig/ToastConfig";
import CenterLoginNavigateModal from "../../Components/modal/centerSmallModal";


const MembershipBuyNow = () => {
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);
  const [vendorMembershipCards, setVendorMembershipCards] = useState([]);
  const [VendorMembershipImageStatus, setVendorMembershipImageStatus] = useState([]);
  const [VendorMembershipImage, setVendorMembershipImage] = useState([]);
  const [vendorDetails, setVendorDetails] = useState([]);
  const [profile, setProfile] = useState();
  const [membershipID, setMembershipID] = useState();
  const location = useLocation();
  const [pageLoaded, setPageLoaded] = useState(false);
  const { vendor_Id, vendorName, from_Page } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  let { vendorId } = useParams();


  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  useEffect(() => {
    membershipCardsList();

  }, []);

  setTimeout(() => {
    setPageLoaded(true);
  }, 3000);

  const membershipCardsList = async () => {
    try {
      let reqData = {
        vendor_id: vendorId,
      };
      let res = await fetchVendorMembershipList(reqData);
      if (res?.status == 200) {
        setVendorMembershipCards(res.data.vendor_membership_list);
        setVendorDetails(res.data.vendor_detail);
        setProfile(res.data);

        const membership_ID = res.data.vendor_membership_list.map(
          (membership) => membership.membership_id
        );

        const VendorMembershipImageStatus = res.data.vendor_membership_list.map(
          (VendorMembershipImageStatus) => VendorMembershipImageStatus.card_pattern_status
        );

        const VendorMembershipImage = res.data.vendor_membership_list.map(
          (VendorMembershipImage) => VendorMembershipImage.card_pattern_image_url
        );

        setVendorMembershipImageStatus(VendorMembershipImageStatus);
        setVendorMembershipImage(VendorMembershipImage);
        setMembershipID(membership_ID);
      };
    } catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        showToast(err.response || "Something went wrong, please try again later", "error");
      }
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white ">
        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
          <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button"
            onClick={() =>
              from_Page == "Membershipdetail" ?
                navigate(`/vendor/${vendorId}`)
                :
                navigate(-1)
            } />
          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">Membership</div>
        </div>
      </div>



      {/* <div style={{ marginBottom: '40%' }} > */}

      <div className='scroller-style-y mb-5 pb-5'>
        <div className="p-3">
          <p className="ff-poppins-bold fs-24 ms-2 secondary-text m-0"> {vendorName}</p>
        </div>
        {
          pageLoaded ?
            vendorMembershipCards.length > 0 ?
              vendorMembershipCards.map((cards, index) => {
                return (
                  <div className=" p-2"
                    onClick={() => {
                      if (userData.user_type == "Guest") { handleShow(); return; }
                      navigate(`/MemberShipDetails/${profile.vendor_id}/${cards.membership_id}`,
                        { state: { vendorId: profile.vendor_id, membership_ID: cards.membership_id, }, });
                    }}  >
                    <MembershipCard
                      buttonName="Buy Now"
                      icon
                      cardColor={VendorMembershipImageStatus == true ? cards.card_pattern_image_url : cards.card_color}
                      data={{
                        membershipDetails: cards,
                        VendorDetails: vendorDetails,
                      }}
                    />
                  </div>
                );
              })
              :
              <>
                <div>
                  <Lottie animationData={empotyLottie} />
                </div>
                <p className='text-dark text-center mt-5 ff-balooPaaji2-bold fs-20 '>No Membership Available</p>

              </>
            :

            <div className='d-flex justify-content-center skeleton-bg'>
              <div >
                <Skeleton height={190} width={375} borderRadius={10} />
                <Skeleton height={190} width={375} borderRadius={10} />
                <Skeleton height={190} width={375} borderRadius={10} />
                <Skeleton height={190} width={375} borderRadius={10} />
              </div>
            </div>


        }
      </div>

      {/* </div> */}




      <CenterLoginNavigateModal
        showModal={showModal}
        pathname={location.pathname}
        onclose={handleClose}
      />
    </>
  );
};
export default MembershipBuyNow;
